import React from "react";

// components
import { Grid, GridCol } from "../../../../components/Grid";
import { Card } from "../../components/Card";
import { Layout, Row } from "../../components/Layout";

// Config
import Config from "../../Config";
import BreakdownChart from "./Cards/BreakdownChart";
// cards
import CohortENPSDetails from "./Cards/CohortENPSDetails";
import SatisfactionFactors from "./Cards/SatisfactionFactors";
import ENPSTrendLineChart from "./Cards/eNPSTrendLineChart";

const eNPS = () => {
	return (
		// topAreaMaxHeight is the height of the top area of the layout that gets the grey background
		<Layout title="eNPS" topAreaMaxHeight={448}>
			<Row height={Config.eNPS.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={12}>
						<Card height={Config.eNPS.ROW_HEIGHTS[0]}>
							<BreakdownChart />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={Config.eNPS.ROW_HEIGHTS[1]}></Row>
			<Row height={Config.eNPS.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={7}>
						<Card height={Config.eNPS.ROW_HEIGHTS[0]}>
							<ENPSTrendLineChart />
						</Card>
					</GridCol>
					<GridCol span={5}>
						<Card height={Config.eNPS.ROW_HEIGHTS[0]}>
							<SatisfactionFactors />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={Config.eNPS.ROW_HEIGHTS[2]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={12}>
						<Card minHeight={Config.eNPS.ROW_HEIGHTS[2]} testId="cohort-enps-card">
							<CohortENPSDetails />
						</Card>
					</GridCol>
				</Grid>
				<Row height={56} />
			</Row>
		</Layout>
	);
};

export default eNPS;
